import * as React from "react";
import CampaignDetail from "./components/CampaignDetail";

export default ({
  data,
}: React.ComponentProps<typeof CampaignDetail>): JSX.Element => {
  return <CampaignDetail data={data} />;
};
